<ng-container *ngIf="isShow">
  <div class="status__row">
    <div
      class="status__name truncate"
      [ngClass]="{ 'status__name_in-group': isGroup }"
      [attr.title]="status.document_name"
    >
      <span class="glyphicon glyphicon-file"></span>{{ status.document_name }}
    </div>

    <div class="status__sent-to">
      <!--none group invite-->
      <ng-container *ngIf="!isGroup; else groupSentTo">
        <div
          class="truncate"
          *ngFor="let email of status.emails"
          [attr.title]="(status.emails.length > 1 && email.order != 0 ? email.order + ' ' : '') + email.email"
        >
          <span *ngIf="status.emails.length > 1 && email.order != 0">( {{ email.order }} )</span>
          {{ email.email }}
          <span *ngIf="status.emails.length > 1 && email.signed === 'true'">(signed)</span>
          <span *ngIf="email.signed === 'declined'">(declined)</span>
          <span *ngIf="email.signed === 'expired' && status.status !== 'fulfilled'">(expired)</span>
        </div>
        <div class="truncate" *ngIf="status.is_signing_link && status.emails.length == 0">
          {{ status.signing_link }}
        </div>
      </ng-container>
      <!--end of none group invite-->

      <!--group invite-->
      <ng-template #groupSentTo>
        <div
          class="truncate"
          [attr.title]="
            (email.order != 0 ? email.order + ' ' : '') +
            email.email +
            (email.signed === 'true' ? ' (signed)' : '')
          "
          *ngFor="let email of status.emails"
        >
          <span *ngIf="email.order != 0">( {{ email.order }} )</span> {{ email.email }}
          <span *ngIf="email.signed === 'true'">(signed)</span>
          <span *ngIf="email.signed === 'declined'">(declined)</span>
          <span *ngIf="email.signed === 'expired' && status.status !== 'fulfilled'">(expired)</span>
        </div>
      </ng-template>
      <!--end of group invite-->
    </div>

    <div class="status__status" [attr.title]="status.status">
      <p class="status__label tac" *ngIf="status.status" [ngClass]="[status.status || 'default']">
        <span
          *ngIf="status.pushedback_log?.errorType"
          (click)="showPushedbackLog(status.pushedback_log)"
          class="status-warning glyphicon glyphicon-warning-sign sn-tooltip"
          title="Something went wrong. Click on the icon for more information."
        >
          <span class="sn-tooltip__text status-tooltip-text"
            >Something went wrong. Click on the icon for more information.</span
          >
        </span>
        {{ status.status }}
      </p>
    </div>

    <div class="status__date-sent truncate" [attr.title]="status.date_sent">
      {{ status.date_sent }}
    </div>

    <div class="status__date-signed truncate" [attr.title]="status.date_signed">
      {{ status.date_signed }}
    </div>

    <div class="status__exp">
      <!--none group invite-->
      <ng-container *ngIf="!isGroup; else groupExp">
        <div
          class="truncate"
          [attr.title]="email.email + ' (' + email.expiration + ')'"
          *ngFor="let email of status.emails"
        >
          {{ email.expiration }}
        </div>
      </ng-container>
      <!--end of none group invite-->

      <!--group invite-->
      <ng-template #groupExp>
        <div
          class="truncate"
          *ngFor="let email of status.emails"
          [attr.title]="email.email + ' (' + email.expiration + ')'"
        >
          {{ email.expiration }}
        </div>
      </ng-template>
      <!--end of group invite-->
    </div>

    <div class="status__actions">
      <div title="Actions">
        <ng-container class="truncate" *ngIf="status.actionText">
          {{ status.actionText }}
        </ng-container>
        <!--actions content-->
        <ng-content select=".sn-invite-status-actions"></ng-content>
      </div>
    </div>
  </div>
</ng-container>
